export default __webpack_public_path__ + "static/media/prev_red.7b266500.png";